// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1f-G8","title":"BackImages_title__ys4-K","images":"BackImages_images__OSAq5"};